const TrackingCalendarViewModuleConstants = {
    rootStateName: "trackingCalendarView",
    prevStateLabel: "tracking-calendar"
};

export default Object.freeze(TrackingCalendarViewModuleConstants);


//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-calendar-view/Constants.js
// module id = azkD
// module chunks = 1